"use strict";

import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { masterChanged, MasterDetail } from "Components/TableCore/master_detail";
import { tbButtonsToggleAttrs, toolbarTableFormButtonsDisabling, toolbarTableFormSetRowKey, toolbarTableKeyboardEvents } from "Actions/Table/TableToolBarActions";
import { UserScriptModel } from "UserActionHandler/UserScriptModel";
import { Fields, System } from "Constants/objects";
import Columns from "Stores/Table/core/table/Columns";
import Rows from "Stores/Table/core/table/Rows";
import { sharedData } from 'SharedData';
import { loadAppObjectsCollection, loadObjectData } from "D5Utils/common_requests";
import { TableDS } from "Stores/Table/core/table/DataSource";
import { objectsEqual, createGuid, createTableID, formatDateToAPI, getAddSSFilter, getSSTableCols, isDateByTypeStr, isEmptyObject, isLookup, setSSTableCols } from "D5Utils/functions";
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { d5TableFocusRowAfterFullEdit } from "Actions/Table/D5TableActions";
import { formEditNestedFormLoaded, formEditUpdate } from "Actions/Forms/FormEditActions";
import D5SummaryRow from "Components/TableCore/summary_row";
import { Messages } from "Messages";
import { tableCustomAction } from "UserActionHandler/UserScriptActions";
/**
 * Class is responsible for creating configuration for a dxDataGrid
 */

var Configurator =
/*#__PURE__*/
function () {
  /**
   * @type {HTMLElement} dxDataGrid
   */

  /**
   * @type {object}
   */

  /**
   * @type {array} Array of FormFields
   */

  /**
   * @type {Array}
   */

  /**
   * @type {FormEditStore}
   * @type {FormEditStore}
   * @private
   */

  /**
   * @type {D5SummaryRow}
   * @private
   */
  function Configurator(options) {
    var _this = this;

    _classCallCheck(this, Configurator);

    _defineProperty(this, "element", null);

    _defineProperty(this, "_config", {
      pageSize: 50
    });

    _defineProperty(this, "viewSource", []);

    _defineProperty(this, "formName", '');

    _defineProperty(this, "objectName", '');

    _defineProperty(this, "type", undefined);

    _defineProperty(this, "editMode", undefined);

    _defineProperty(this, "keyField", '');

    _defineProperty(this, "systemKeyField", '');

    _defineProperty(this, "systemFields", []);

    _defineProperty(this, "formID", undefined);

    _defineProperty(this, "formUUID", '');

    _defineProperty(this, "parentFormID", undefined);

    _defineProperty(this, "filtersData", null);

    _defineProperty(this, "userEvents", null);

    _defineProperty(this, "columnNames", []);

    _defineProperty(this, "cancelRowChanges", null);

    _defineProperty(this, "saveRowChanges", null);

    _defineProperty(this, "groups", null);

    _defineProperty(this, "editingRowInfo", {});

    _defineProperty(this, "colSetValueFuncs", new Map());

    _defineProperty(this, "updating", false);

    _defineProperty(this, "formEvents", {});

    _defineProperty(this, "additionalFilter", {});

    _defineProperty(this, "currentRowIndex", null);

    _defineProperty(this, "popupInst", null);

    _defineProperty(this, "initNewRowData", null);

    _defineProperty(this, "requestColumns", null);

    _defineProperty(this, "tableData", null);

    _defineProperty(this, "relationType", null);

    _defineProperty(this, "saving", false);

    _defineProperty(this, "_parentUUID", null);

    _defineProperty(this, "_masterObjKeyFieldName", null);

    _defineProperty(this, "_detailObjKeyFieldName", null);

    _defineProperty(this, "requiredFields", []);

    _defineProperty(this, "filterEvents", []);

    _defineProperty(this, "isShowTotals", false);

    _defineProperty(this, "editingRowKey", null);

    _defineProperty(this, "_owner", void 0);

    _defineProperty(this, "_formFilters", void 0);

    _defineProperty(this, "_totalRow", null);

    _defineProperty(this, "_addFilter", {});

    _defineProperty(this, "dataContextMenu", {});

    var element = options.element,
        formID = options.formID,
        metadata = options.metadata,
        formUUID = options.formUUID,
        parentFormID = options.parentFormID,
        filtersData = options.filtersData,
        userEvents = options.userEvents,
        viewSource = options.viewSource,
        cancelRowChanges = options.cancelRowChanges,
        saveRowChanges = options.saveRowChanges,
        groups = options.groups,
        popupInst = options.popupInst,
        requestColumns = options.requestColumns,
        tableData = options.tableData,
        relationType = options.relationType,
        masterObjKeyFieldName = options.masterObjKeyFieldName,
        detailObjKeyFieldName = options.detailObjKeyFieldName,
        parentUUID = options.parentUUID,
        owner = options.owner,
        formFilters = options.formFilters,
        loadPanel = options.loadPanel,
        filterEvents = options.filterEvents,
        dataContextMenu = options.dataContextMenu;
    this.formName = metadata[Fields.Name];
    this.objectName = metadata[Fields.ObjectID_Name];
    this.type = metadata[Fields.Type];
    this.keyField = metadata[Fields.ObjectID_KeyObjectFieldID_Name];
    this.keyFieldType = metadata[Fields.ObjectID_KeyObjectFieldID_FieldType];
    this.isShowTotals = metadata[Fields.IsShowTotals];
    this.formID = formID;
    this.element = element;
    this.formUUID = formUUID;
    this.parentFormID = parentFormID;
    this.filtersData = this.getFilter(filtersData);
    this.userEvents = userEvents;
    this.viewSource = viewSource;
    this.cancelRowChanges = cancelRowChanges;
    this.saveRowChanges = saveRowChanges;
    this.groups = groups;
    this.popupInst = popupInst;
    this.systemKeyField = this.addSystemField(this.keyField);
    this.loadPanel = loadPanel;
    this.requestColumns = requestColumns;
    this.tableData = tableData;
    this.relationType = relationType;
    this._parentUUID = parentUUID;
    this._masterObjKeyFieldName = masterObjKeyFieldName;
    this._detailObjKeyFieldName = detailObjKeyFieldName;
    this._owner = owner;
    this._formFilters = formFilters;
    this.requiredFilterFields = formFilters.filter(function (f) {
      return f[Fields.IsRequired];
    }).map(function (f) {
      return f[Fields.ObjectFieldID_Name] || f[Fields.Name];
    });
    this.filterEvents = filterEvents;
    this.dataContextMenu = dataContextMenu;
    this._totalRow = new D5SummaryRow(this.viewSource, this.isShowTotals);
    this._addFilter = getAddSSFilter(this.getLSName());
    this.processUSTableModel = this.processUSTableModel.bind(this);

    this.editMode = function () {
      var _System$EDIT_MODE = System.EDIT_MODE,
          CELL = _System$EDIT_MODE.CELL,
          INLINE = _System$EDIT_MODE.INLINE;
      var edtMode = metadata[Fields.EditMode];
      if (_this.isNestedObject() && edtMode === CELL) return edtMode;
      if (edtMode === CELL) return INLINE;
      return edtMode;
    }();
  }
  /**
   * @return {object} Instance of dxDataGrid
   */


  _createClass(Configurator, [{
    key: "instance",
    value: function instance() {
      return this.element.dxDataGrid('instance');
    }
  }, {
    key: "isNestedObject",
    value: function isNestedObject() {
      return this.tableData != null;
    }
  }, {
    key: "addSystemField",
    value: function addSystemField(name) {
      var system = System.SYSTEM_PREFIX + name;
      this.systemFields.push(system);
      return system;
    }
  }, {
    key: "inlineEditing",
    value: function inlineEditing(value) {
      if (typeof value !== 'undefined') sharedData.inlineEditing = value;
      if (value === false) this.editingRowInfo = {};
      return sharedData.inlineEditing;
    }
  }, {
    key: "getFilter",
    value: function getFilter(preFilter) {
      preFilter = preFilter == null ? {} : preFilter;
      var detail = MasterDetail.getTable(this.formID);
      var filter = detail ? detail.get('filter') : {};
      filter = !isEmptyObject(filter) ? _objectSpread({}, preFilter, filter) : preFilter;
      return !isEmptyObject(filter) ? filter : null;
    }
  }, {
    key: "hasParent",
    value: function hasParent() {
      return this.parentFormID != null;
    }
  }, {
    key: "getLSName",
    value: function getLSName() {
      return createTableID(this.formID, this.parentFormID);
    }
  }, {
    key: "config",
    value: function config() {
      return this._config;
    }
    /**
     * @param {string} fieldName
     * @return {object|undefined}
     */

  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      return _.find(this.viewSource, function (item) {
        return item[Fields.Name] === fieldName;
      });
    }
    /**
     *
     * @param {Object} data
     * @param {Array} viewSource
     * @param {Object} instance
     */

  }, {
    key: "sourceDataToColumnData",
    value: function sourceDataToColumnData(data, rowIndex) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var getValue = function getValue(field) {
          return Columns.isLookup(field) ? data[field[Fields.KeyFilterField]] : data[field[Fields.ObjectFieldID_Name]];
        };

        var promises = [];
        var keyRowTable;
        var key = data[_this2.keyField] ? data[_this2.keyField] : createGuid();

        var tableDataSource = _this2.instance().getDataSource().items();

        _.each(_this2.columnNames, function (name) {
          var field = _this2.getFieldByName(name);

          if (Columns.isSystemField(field)) {
            return;
          }

          var value = getValue(field);

          if (isLookup(field)) {
            if (value == null) {
              var _promises$push;

              promises.push((_promises$push = {}, _defineProperty(_promises$push, field.Name, null), _defineProperty(_promises$push, System.SYSTEM_PREFIX + field.Name, null), _promises$push));
            } else {
              var displayFld = field[Fields.DisplayField];
              promises.push(loadObjectData({
                filter: _defineProperty({}, Fields.ID, value),
                columns: [Fields.ID, displayFld],
                objectName: field[Fields.ObjectFieldID_LinkedObjectID_Name]
              }).then(function (data) {
                var _Promise$resolve;

                return Promise.resolve((_Promise$resolve = {}, _defineProperty(_Promise$resolve, field.Name, data[0][displayFld]), _defineProperty(_Promise$resolve, System.SYSTEM_PREFIX + field.Name, data[0][Fields.ID]), _Promise$resolve));
              }));
            }
          } else {
            promises.push(Promise.resolve(_defineProperty({}, field.Name, value)));
          }
        });

        if (_this2.inlineEditing() === System.FORM_EDIT_CREATE_MODE.EDIT) {
          keyRowTable = tableDataSource.length && !_.isEmpty(tableDataSource[rowIndex]) && tableDataSource[rowIndex][_this2.systemKeyField] ? tableDataSource[rowIndex][_this2.systemKeyField] : key;
        }

        promises.push(Promise.resolve(_defineProperty({}, _this2.systemKeyField, keyRowTable || key)));
        Promise.all(promises).then(function (data) {
          resolve((data || []).reduce(function (accum, curr) {
            return _objectSpread({}, accum, curr);
          }, {}));
        });
      });
    }
  }, {
    key: "exportToXls",
    value: function exportToXls(exportSelected) {
      this.instance().exportToExcel(exportSelected);
    }
  }, {
    key: "prepareNestedData",
    value: function prepareNestedData(data) {
      return TableDS.prepareSourceData({
        data: data,
        columnNames: this.columnNames,
        keyField: this.keyField,
        viewSource: this.viewSource,
        isNested: true
      });
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      var keys = this.instance().getVisibleRows().map(function (row) {
        return row.key;
      });
      this.instance().selectRows(keys, true);
    }
  }, {
    key: "isDetail",
    value: function isDetail() {
      return this.relationType === System.RELATION_TYPE.DETAIL;
    }
  }, {
    key: "buildConfig",
    value: function () {
      var _buildConfig = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var columns, lastFocusedCellData, props, model, newModel, _config;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = new Columns({
                  settings: this
                });

                if (!this.isNestedObject()) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this.prepareNestedData(this.tableData);

              case 4:
                this.tableData = _context.sent;

              case 5:
                this.rowCore = new Rows({
                  settings: this
                });

                if (!(window[this.formName] && typeof window[this.formName]['formInit'] === 'function')) {
                  _context.next = 21;
                  break;
                }

                props = {
                  pageSize: this._config.pageSize || 50,
                  filter: {
                    formFields: this.viewSource,
                    viewSource: this._formFilters,
                    lsColumns: getSSTableCols(this.getLSName()),
                    addFilter: getAddSSFilter(this.getLSName())
                  }
                };
                model = new UserScriptModel(this.viewSource, {}, props, System.USER_SCRIPTS_INITIATOR.TABLE);
                _context.prev = 9;
                newModel = window[this.formName]['formInit'](model);
                this.saveFilterFromModelProps(newModel);
                this.updating = 'formInit';
                _context.next = 15;
                return this.updateUserEvent({
                  nextData: _objectSpread({}, newModel.getSourceData()),
                  nextView: _toConsumableArray(newModel.getSourceView()),
                  formEvents: _objectSpread({}, newModel.formEvents),
                  funcName: 'formInit',
                  rowIndex: -1,
                  props: _objectSpread({}, newModel.getProps())
                }).catch(function (e) {
                  showSnackBar({
                    type: System.SNACKBAR_TYPES.Error,
                    message: e.message
                  });
                });

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](9);
                _context.next = 21;
                return this.updateUserEvent({
                  nextData: {},
                  nextView: _toConsumableArray(this.viewSource),
                  formEvents: {},
                  funcName: 'formInit',
                  rowIndex: -1,
                  props: props,
                  errorMessage: _context.t0.message
                });

              case 21:
                _config = {
                  columns: columns.build(),
                  dataSource: new TableDS(this).dataSource(),
                  editing: _objectSpread({}, {
                    texts: {
                      // Hides the confirmation dialog
                      confirmDeleteMessage: null
                    }
                  }, function () {
                    var CELL = System.EDIT_MODE.CELL;

                    switch (_this3.editMode) {
                      case CELL:
                        return {
                          mode: 'cell',
                          allowUpdating: true,
                          allowAdding: true
                        };

                      default:
                        return {};
                    }
                  }()),
                  remoteOperations: {
                    filtering: !this.isNestedObject(),
                    paging: !this.isNestedObject(),
                    sorting: !this.isNestedObject(),
                    summary: !this.isNestedObject()
                  },
                  summary: {
                    totalItems: this.isShowTotals ? this._totalRow.totalItems : []
                  },
                  repaintChangesOnly: true,
                  highlightChanges: true,
                  keyExpr: this.isNestedObject() ? this.systemKeyField : undefined,
                  stateStoring: {
                    enabled: true,
                    type: "custom",
                    savingTimeout: 1000,
                    customLoad: function customLoad() {},
                    customSave: function customSave(state) {
                      Columns.saveColumnsToLS(state, _this3.viewSource, _this3.instance(), _this3.getLSName());

                      _this3.setModeClearQuickFiltersBtn(_this3.formID, _this3.getLSName());
                    }
                  },
                  "export": {
                    enabled: true,
                    fileName: this.objectName,
                    allowExportSelectedData: true
                  },
                  sorting: {
                    mode: "multiple"
                  },
                  filterRow: {
                    visible: true,
                    applyFilter: "auto"
                  },
                  pageSize: 50,
                  showRowLines: false,
                  showColumnLines: true,
                  rowAlternationEnabled: true,
                  allowColumnResizing: true,
                  columnResizingMode: "widget",
                  columnMinWidth: 130,
                  selectionFilter: [],
                  selection: {
                    mode: "multiple",
                    allowSelectAll: true,
                    selectAllMode: 'page',
                    showCheckBoxesMode: 'none'
                  },
                  showBorders: true,
                  allowColumnReordering: true,
                  columnFixing: {
                    enabled: true
                  },
                  hoverStateEnabled: true,
                  scrolling: {
                    mode: "infinite",
                    // mode: "virtual",
                    // rowRenderingMode: "virtual",
                    // columnRenderingMode: "virtual",
                    showScrollbar: 'always'
                  },
                  errorRowEnabled: false,
                  onRowPrepared: function onRowPrepared(options) {
                    if (options && options.rowElement) {
                      $(options.rowElement[0]).attr('data-id', options.key);
                    }
                  },
                  onEditorPreparing: function onEditorPreparing(col) {
                    switch (col.parentType) {
                      case 'filterRow':
                        col.cancel = true;
                        break;

                      case 'dataRow':
                        col.cancel = true;

                        _this3.rowCore.setupEditor(col);

                        break;

                      case 'headerRow':
                        // Do something
                        break;
                    }
                  },
                  onCellPrepared: function onCellPrepared(_ref) {
                    var rowType = _ref.rowType,
                        column = _ref.column,
                        cellElement = _ref.cellElement;
                    if (rowType === 'filter' && column.dataField !== "".concat(System.SYSTEM_PREFIX, "buttons_panel")) _this3.rowCore.filterCell(column, cellElement);
                  },
                  onContentReady: function onContentReady(_ref2) {
                    var component = _ref2.component,
                        element = _ref2.element;
                    var _System$TOOLBAR_BTN_C = System.TOOLBAR_BTN_CLASSES,
                        EDIT = _System$TOOLBAR_BTN_C.EDIT,
                        DEL = _System$TOOLBAR_BTN_C.DEL,
                        SELECT = _System$TOOLBAR_BTN_C.SELECT,
                        DESELECT = _System$TOOLBAR_BTN_C.DESELECT,
                        SEARCH = _System$TOOLBAR_BTN_C.SEARCH,
                        ADD = _System$TOOLBAR_BTN_C.ADD,
                        REFRESH = _System$TOOLBAR_BTN_C.REFRESH,
                        EXPORT = _System$TOOLBAR_BTN_C.EXPORT;

                    var ls = _this3.getLSName();

                    var row = element.find('.dx-datagrid-filter-row');
                    var rowFilter = JSON.parse(sessionStorage.getItem("".concat(ls, "-row-filter")) || '{}');

                    if (rowFilter.shown && !row.hasClass('shown')) {
                      row.addClass('shown');
                      tbButtonsToggleAttrs(['show-header-row-filter'], true, _this3.formUUID);
                    }

                    if (sharedData.lastRowIndex) d5TableFocusRowAfterFullEdit(sharedData.lastRowIndex);
                    if (_this3.parentFormID != null) formEditNestedFormLoaded({
                      UUID: _this3.formUUID,
                      parentFormID: _this3.parentFormID
                    });

                    if (_this3.isDetail() && _this3.filtersData && !isEmptyObject(_this3.filtersData) && Object.values(_this3.filtersData)[0] == null) {
                      toolbarTableFormButtonsDisabling([EDIT, DEL, SELECT, DESELECT, SEARCH, ADD, REFRESH, EXPORT], true, _this3.formUUID);
                    }

                    component.option('formUUID', _this3.formUUID);
                  },
                  onSelectionChanged: function onSelectionChanged(_ref3) {
                    var selectedRowKeys = _ref3.selectedRowKeys,
                        selectedRowsData = _ref3.selectedRowsData;
                    var _System$TOOLBAR_BTN_C2 = System.TOOLBAR_BTN_CLASSES,
                        EDIT = _System$TOOLBAR_BTN_C2.EDIT,
                        MULTI_EDIT = _System$TOOLBAR_BTN_C2.MULTI_EDIT,
                        DEL = _System$TOOLBAR_BTN_C2.DEL,
                        DESELECT = _System$TOOLBAR_BTN_C2.DESELECT,
                        GOTO = _System$TOOLBAR_BTN_C2.GOTO,
                        REPORTS = _System$TOOLBAR_BTN_C2.REPORTS;
                    var selectedLen = selectedRowKeys.length;
                    var isMultiSelect = false;
                    var sourceRow = Configurator.columnDataToSourceData({
                      data: selectedRowsData[0],
                      viewSource: _this3.viewSource,
                      instance: _this3.instance()
                    });

                    if (_this3.inlineEditing()) {
                      _this3.instance().hasEditData() ? _this3.saveRowChanges() : _this3.cancelRowChanges();

                      _this3.instance().deselectRows(selectedRowKeys);

                      return;
                    }

                    switch (selectedLen) {
                      case 0:
                        toolbarTableFormButtonsDisabling([EDIT, DEL, GOTO, REPORTS, MULTI_EDIT, DESELECT], true, _this3.formUUID);
                        break;

                      case 1:
                        toolbarTableFormButtonsDisabling([EDIT, DEL, DESELECT, REPORTS, MULTI_EDIT, GOTO], false, _this3.formUUID);
                        break;

                      default:
                        isMultiSelect = true;
                    }

                    if (isMultiSelect) {
                      toolbarTableFormButtonsDisabling([EDIT], true, _this3.formUUID);
                      toolbarTableFormButtonsDisabling([DESELECT, GOTO, REPORTS, MULTI_EDIT], false, _this3.formUUID);
                    }

                    if (selectedLen < 2) {
                      _this3.updateDetails(selectedRowKeys[0], sourceRow);
                    }

                    _this3.onSelectionChanged({
                      sourceRow: sourceRow,
                      key: selectedRowKeys
                    });
                  },
                  onCellClick: function onCellClick(_ref4) {
                    var value = _ref4.value,
                        rowIndex = _ref4.rowIndex,
                        cellElement = _ref4.cellElement,
                        rowType = _ref4.rowType,
                        event = _ref4.event,
                        column = _ref4.column;
                    var focusedRow = $('.focused-cell', _this3.element);

                    if (rowType === 'header' && !_this3.isNestedObject()) {
                      _this3.loadPanel.show();

                      _this3.instance().pageIndex(0);
                    }

                    if (focusedRow.length) $(focusedRow[0]).removeClass('focused-cell');
                    lastFocusedCellData = value;
                    $(cellElement[0]).addClass('focused-cell');
                    toolbarTableFormSetRowKey(null, _this3.formUUID);
                    _this3.currentRowIndex = rowIndex;
                  },
                  onKeyDown: function onKeyDown(_ref5) {
                    var component = _ref5.component,
                        event = _ref5.event;
                    //solution: devexpress.com/Support/Center/Question/Details/T349803/
                    var selKey = component.getSelectedRowKeys();

                    if (selKey.length) {
                      var currentKey = selKey[0];
                      var index = component.getRowIndexByKey(currentKey);

                      if (event.keyCode === 38) {
                        index--;

                        if (index >= 0) {
                          component.selectRowsByIndexes([index]);
                          event.stopPropagation();
                        }
                      } else if (event.keyCode === 40) {
                        index++;
                        component.selectRowsByIndexes([index]);
                        event.stopPropagation();
                      }

                      _this3.currentRowIndex = index;
                    } //edit operation, key: Enter


                    if (event.keyCode === 13) {
                      if (_this3.inlineEditing() && _this3.editMode === System.EDIT_MODE.INLINE) {
                        _this3.saveRowChanges();
                      } else if (!_this3.inlineEditing()) {
                        toolbarTableKeyboardEvents(_this3.formUUID, event);
                      }

                      event.preventDefault();
                      event.stopPropagation();
                    } else //copy to clipboard operation, key: Ctrl + C
                      if (event.ctrlKey && event.keyCode === 67) {
                        navigator.clipboard.writeText(lastFocusedCellData);
                        event.preventDefault();
                        event.stopPropagation();
                      } else //select all visible rows: Ctrl + A
                        if (event.ctrlKey && event.keyCode === 65) {
                          _this3.selectAll();

                          event.preventDefault();
                          event.stopPropagation();
                        }
                  },
                  onRowClick: function onRowClick(_ref6) {
                    var component = _ref6.component,
                        rowType = _ref6.rowType;

                    if (rowType !== 'data') {
                      return;
                    }

                    if (!component.clickCount) component.clickCount = 1;else component.clickCount = component.clickCount + 1;
                    /* Would be nice to check if you are double clicking the same row */

                    if (component.clickCount === 1) {
                      // Capture clicktime on first click
                      component.lastClickTime = new Date();
                      /* Set a timer to clear the click info if no second click occurs within the interval...
                         should be just longer than your double click interval test */

                      setTimeout(function () {
                        component.lastClickTime = 0;
                        component.clickCount = 0;
                      }, 350);
                    } else if (component.clickCount === 2) {
                      // Check your click interval.
                      if (new Date() - component.lastClickTime < 300) {
                        //Double click code
                        toolbarTableKeyboardEvents(_this3.formUUID, {
                          keyCode: 13,
                          //Enter
                          target: {
                            tagName: "TABLE"
                          }
                        });
                      } // Reset your click info


                      component.clickCount = 0;
                      component.lastClickTime = 0;
                    }
                  },
                  onEditingStart: function onEditingStart(e) {
                    if (_this3.updating) {
                      e.cancel = true;
                      return;
                    }

                    var data = e.data,
                        key = e.key;
                    _this3.editingRowInfo = _objectSpread({}, data);
                    var DEL = System.TOOLBAR_BTN_CLASSES.DEL;

                    if (_this3.editMode === System.EDIT_MODE.CELL && key != null) {
                      _this3.inlineEditing('cell');

                      toolbarTableFormButtonsDisabling([DEL], false, _this3.formUUID);
                      _this3.editingRowKey = key;
                    }

                    if (typeof _this3.formEvents.onInitialized === 'function' || typeof _this3.formEvents.onBeforeEditRow === 'function') {
                      var sourceRow = Configurator.columnDataToSourceData({
                        data: _this3.editingRowInfo,
                        viewSource: _this3.viewSource,
                        instance: _this3.instance()
                      });

                      _this3.onBeforeEditRow({
                        sourceRow: sourceRow,
                        key: key
                      });
                    }
                  },
                  onInitNewRow: function onInitNewRow(e) {
                    e.data = _objectSpread({}, _this3.initNewRowData || {});
                    var sourceData = Configurator.columnDataToSourceData({
                      data: e.data,
                      viewSource: _this3.viewSource,
                      instance: _this3.instance()
                    });

                    _this3.emitUSTableEvent({
                      sourceRow: sourceData,
                      eventName: 'onInitNewRow',
                      targetFunc: _this3.processUSTableModel
                    }).then(function (_ref7) {
                      var sourceRow = _ref7.sourceRow;

                      _this3.onBeforeEditRow({
                        sourceRow: sourceRow
                      }).then(function (_ref8) {
                        var sourceRow = _ref8.sourceRow;

                        _this3.sourceDataToColumnData(sourceRow, 0).then(function (colData) {
                          _this3.initNewRowData = null;
                          _this3.editingRowInfo = colData;
                        });
                      });
                    });
                  },
                  onRowInserted: function onRowInserted() {
                    if (_this3.editMode === System.EDIT_MODE.CELL && _this3.isNestedObject()) {
                      _this3.instance().focus();

                      _this3.inlineEditing(false);

                      _this3.rowCore.sendNestedData();
                    }
                  },
                  onRowUpdated: function onRowUpdated() {
                    if (_this3.editMode === System.EDIT_MODE.CELL && _this3.isNestedObject()) {
                      _this3.instance().focus();

                      _this3.inlineEditing(false);

                      _this3.rowCore.sendNestedData();

                      _this3.instance().cancelEditData();
                    }
                  },
                  onFocusedCellChanged: function onFocusedCellChanged(_ref9) {
                    var rowIndex = _ref9.rowIndex;
                    var DEL = System.TOOLBAR_BTN_CLASSES.DEL;

                    if (_this3.editMode === System.EDIT_MODE.CELL && _this3.isNestedObject() && !~rowIndex) {
                      toolbarTableFormButtonsDisabling([DEL], true, _this3.formUUID);
                    }
                  },
                  onContextMenuPreparing: function onContextMenuPreparing(e) {
                    var component = e.component,
                        column = e.column,
                        row = e.row;

                    if (!row) {
                      e.items = _this3.dataContextMenu;
                      return;
                    }

                    var currentRowKey = row.key;

                    _.mapObject(_this3.dataContextMenu, function (item) {
                      //записываем данные строки для вложенных списков
                      if (item['items']) _.mapObject(item['items'], function (obj) {
                        return obj['rowData'] = row.data;
                      });
                      return item['rowId'] = row.key;
                    });

                    toolbarTableFormSetRowKey(currentRowKey, _this3.formUUID);

                    switch (row.rowType) {
                      case 'data':
                        e.items = _this3.dataContextMenu;
                        break;

                      case 'header':
                        e.items && e.items.splice(3, 0, {
                          disabled: false,
                          icon: "far fa-eye-slash table-header-contextmenu-item hide-column",
                          onItemClick: function onItemClick() {
                            component.columnOption(column.index, 'visible', false);
                          },
                          text: "Hide column",
                          beginGroup: true
                        });
                        break;
                    }
                  }
                };
                this._config = _config;
                return _context.abrupt("return", this._config);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 17]]);
      }));

      function buildConfig() {
        return _buildConfig.apply(this, arguments);
      }

      return buildConfig;
    }()
  }, {
    key: "resetSelection",
    value: function resetSelection() {
      if (this.shouldResetSelection()) {
        this.instance().clearSelection();
      }
    }
  }, {
    key: "shouldResetSelection",
    value: function shouldResetSelection() {
      var keys = this.instance().getSelectedRowKeys();
      var noKeys = keys.length === 0;
      var visibleRows = this.instance().getVisibleRows();
      return !noKeys && !keys.every(function (key) {
        return visibleRows.some(function (row) {
          return row.key === key;
        });
      });
    }
  }, {
    key: "updateDetails",
    value: function updateDetails(key, rowData) {
      masterChanged({
        masterKey: this.formID,
        objID: key,
        rowData: Configurator.columnDataToSourceData({
          data: rowData,
          viewSource: this.viewSource,
          instance: this.instance()
        })
      });
    }
    /**
     * @param {object} sourceRow The kind of server data
     * @param eventName
     * @param key
     * @param {Array} [args] Additional arguments that must be passed to a user-defined function.
     * @param {function} [targetFunc] - Must return an object {sourceRow, model} and pass {eventName, rowIndex, model, props}
     * @return {object} The kind of server data and UserScriptModel {sourceRow, model}
     */

  }, {
    key: "emitUSTableEvent",
    value: function () {
      var _emitUSTableEvent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref10) {
        var sourceRow, eventName, key, args, targetFunc, ADD, rowIndex, props, model, _this$formEvents, newModel;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sourceRow = _ref10.sourceRow, eventName = _ref10.eventName, key = _ref10.key, args = _ref10.args, targetFunc = _ref10.targetFunc;

                if (!(typeof this.formEvents[eventName] === 'function')) {
                  _context2.next = 24;
                  break;
                }

                if (isEmptyObject(args)) args = [];
                ADD = System.FORM_EDIT_CREATE_MODE.ADD;
                rowIndex = Array.isArray(key) ? -1 : this.inlineEditing() === ADD ? 0 : this.instance().getRowIndexByKey(key);
                props = {
                  owner: this._owner,
                  pageSize: this._config.pageSize,
                  rowKeys: key,
                  filter: {
                    formFields: this.viewSource,
                    viewSource: this._formFilters,
                    lsColumns: getSSTableCols(this.getLSName()),
                    addFilter: getAddSSFilter(this.getLSName())
                  }
                };
                model = new UserScriptModel(this.viewSource, sourceRow, props, System.USER_SCRIPTS_INITIATOR.TABLE);
                _context2.prev = 7;
                _context2.next = 10;
                return (_this$formEvents = this.formEvents)[eventName].apply(_this$formEvents, [model].concat(_toConsumableArray(args)));

              case 10:
                newModel = _context2.sent;
                if (newModel) model = newModel;
                this.updating = eventName;

                if (!(typeof targetFunc === 'function')) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", targetFunc({
                  eventName: eventName,
                  rowIndex: rowIndex,
                  model: model,
                  props: props
                }));

              case 15:
                return _context2.abrupt("return", {
                  sourceRow: model.getSourceData(),
                  model: model
                });

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](7);
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: _context2.t0.message
                });
                return _context2.abrupt("return", Promise.resolve({
                  sourceRow: {},
                  model: model
                }));

              case 22:
                _context2.next = 25;
                break;

              case 24:
                return _context2.abrupt("return", Promise.resolve({
                  sourceRow: sourceRow
                }));

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 18]]);
      }));

      function emitUSTableEvent(_x) {
        return _emitUSTableEvent.apply(this, arguments);
      }

      return emitUSTableEvent;
    }()
    /**
     * @param {UserScriptModel} model
     */

  }, {
    key: "saveFilterFromModelProps",
    value: function saveFilterFromModelProps(model) {
      var props = model.getProps();

      if (props.filter && props.filter.isChanged) {
        var _props$filter$filter = props.filter.filter,
            lsColumns = _props$filter$filter.lsColumns,
            addFilter = _props$filter$filter.addFilter;
        this.rowCore.saveFilter(lsColumns, addFilter);
      }
    }
  }, {
    key: "emitFilterFieldUserEvent",
    value: function emitFilterFieldUserEvent(_ref11) {
      var eventName = _ref11.eventName,
          formUUID = _ref11.formUUID,
          rowIndex = _ref11.rowIndex,
          lsColumns = _ref11.lsColumns,
          addFilter = _ref11.addFilter;

      if (this.updating) {
        return;
      }

      if (eventName && !sharedData.inlineEditing) {
        this.updating = eventName;
        tableCustomAction({
          fileName: this.formName,
          funcName: eventName,
          nextStore: {},
          viewStore: this.viewSource,
          rowIndex: -1,
          formUUID: formUUID,
          props: {
            owner: this._owner,
            filter: {
              formFields: this.viewSource,
              viewSource: this._formFilters,
              lsColumns: lsColumns,
              addFilter: addFilter
            }
          }
        });
      }
    }
  }, {
    key: "processUSTableModel",
    value: function () {
      var _processUSTableModel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_ref12) {
        var _this4 = this;

        var eventName, rowIndex, model, props, sourceRow;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                eventName = _ref12.eventName, rowIndex = _ref12.rowIndex, model = _ref12.model, props = _ref12.props;
                _context3.next = 3;
                return this.updateUserEvent({
                  nextData: _objectSpread({}, model.getSourceData()),
                  nextView: _toConsumableArray(this.viewSource),
                  funcName: eventName,
                  props: props,
                  rowIndex: rowIndex
                }).catch(function (e) {
                  return _this4.updateUserEvent({
                    nextData: {},
                    nextView: _toConsumableArray(_this4.viewSource),
                    funcName: eventName,
                    rowIndex: -1,
                    props: props,
                    errorMessage: e.message
                  });
                });

              case 3:
                sourceRow = _context3.sent;
                return _context3.abrupt("return", {
                  sourceRow: sourceRow,
                  model: model
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function processUSTableModel(_x2) {
        return _processUSTableModel.apply(this, arguments);
      }

      return processUSTableModel;
    }()
  }, {
    key: "onBeforeEditRow",
    value: function () {
      var _onBeforeEditRow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(_ref13) {
        var sourceRow, _ref13$key, key, eventName, _ref14, sRow, model;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sourceRow = _ref13.sourceRow, _ref13$key = _ref13.key, key = _ref13$key === void 0 ? null : _ref13$key;

                if (typeof this.formEvents.onInitialized === 'function') {
                  console.warn(Messages.Warning.OnInitializedDeprecated);
                  eventName = 'onInitialized';
                } else if (typeof this.formEvents.onBeforeEditRow === 'function') {
                  eventName = 'onBeforeEditRow';
                }

                _context4.next = 4;
                return this.emitUSTableEvent({
                  sourceRow: sourceRow,
                  eventName: eventName,
                  key: key,
                  targetFunc: this.processUSTableModel
                });

              case 4:
                _ref14 = _context4.sent;
                sRow = _ref14.sourceRow;
                model = _ref14.model;
                if (model) this.saveFilterFromModelProps(model);
                return _context4.abrupt("return", {
                  sourceRow: sRow
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onBeforeEditRow(_x3) {
        return _onBeforeEditRow.apply(this, arguments);
      }

      return onBeforeEditRow;
    }()
  }, {
    key: "onRowBeforeSave",
    value: function () {
      var _onRowBeforeSave = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(_ref15) {
        var sourceRow, key, eventName, _ref16, sRow, model;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sourceRow = _ref15.sourceRow, key = _ref15.key;

                if (typeof this.formEvents.onSaveRow === 'function') {
                  console.warn(Messages.Warning.OnSaveRowDeprecated);
                  eventName = 'onSaveRow';
                } else if (typeof this.formEvents.onRowBeforeSave === 'function') {
                  eventName = 'onRowBeforeSave';
                }

                _context5.next = 4;
                return this.emitUSTableEvent({
                  sourceRow: sourceRow,
                  eventName: eventName,
                  key: key,
                  targetFunc: this.processUSTableModel
                });

              case 4:
                _ref16 = _context5.sent;
                sRow = _ref16.sourceRow;
                model = _ref16.model;
                if (model) this.saveFilterFromModelProps(model);
                return _context5.abrupt("return", sRow);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onRowBeforeSave(_x4) {
        return _onRowBeforeSave.apply(this, arguments);
      }

      return onRowBeforeSave;
    }()
  }, {
    key: "onRowAfterSave",
    value: function () {
      var _onRowAfterSave = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(_ref17) {
        var sourceRow, key, eventName, _ref18, model;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                sourceRow = _ref17.sourceRow, key = _ref17.key;
                eventName = 'onRowAfterSave';
                _context6.next = 4;
                return this.emitUSTableEvent({
                  sourceRow: sourceRow,
                  eventName: eventName,
                  key: key,
                  targetFunc: this.processUSTableModel
                });

              case 4:
                _ref18 = _context6.sent;
                model = _ref18.model;
                if (model) this.saveFilterFromModelProps(model);

                if (this._owner && model) {
                  formEditUpdate({
                    nextData: model._ownerModel.getSourceData(),
                    nextView: model._ownerModel.getSourceView(),
                    props: {},
                    formEvents: {},
                    formUUID: model._owner.formUUID,
                    funcName: eventName
                  });
                }

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onRowAfterSave(_x5) {
        return _onRowAfterSave.apply(this, arguments);
      }

      return onRowAfterSave;
    }()
  }, {
    key: "onSelectionChanged",
    value: function () {
      var _onSelectionChanged = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(_ref19) {
        var sourceRow, key, eventName, _ref20, model;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                sourceRow = _ref19.sourceRow, key = _ref19.key;
                eventName = 'onSelectionChanged';
                _context7.next = 4;
                return this.emitUSTableEvent({
                  sourceRow: sourceRow,
                  eventName: eventName,
                  key: key,
                  targetFunc: this.processUSTableModel
                });

              case 4:
                _ref20 = _context7.sent;
                model = _ref20.model;
                if (model) this.saveFilterFromModelProps(model);

                if (this._owner && model) {
                  formEditUpdate({
                    nextData: model._ownerModel.getSourceData(),
                    nextView: model._ownerModel.getSourceView(),
                    formEvents: {},
                    formUUID: model._owner.formUUID,
                    funcName: eventName,
                    props: {
                      tables: model.getTables()
                    }
                  });
                }

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onSelectionChanged(_x6) {
        return _onSelectionChanged.apply(this, arguments);
      }

      return onSelectionChanged;
    }()
  }, {
    key: "onEditorPreparing",
    value: function () {
      var _onEditorPreparing = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(_ref21) {
        var sourceRow, key, dataField, eventName, _ref22, model, views, viewsNames, loaded, obj, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, view;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                sourceRow = _ref21.sourceRow, key = _ref21.key, dataField = _ref21.dataField;
                eventName = 'onEditorPreparing';
                _context8.next = 4;
                return this.emitUSTableEvent({
                  sourceRow: sourceRow,
                  eventName: eventName,
                  key: key,
                  args: [dataField]
                });

              case 4:
                _ref22 = _context8.sent;
                model = _ref22.model;

                if (model) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return", this.viewSource);

              case 8:
                views = model.getSourceView();
                /*это значит что в пользовательском скрипте задали новый ObjectFieldID_LinkedObjectID_Name
                * в таком случае зануляется ObjectFieldID_LinkedObjectID и его нужно отдельно запросить
                * */

                viewsNames = views.filter(function (v) {
                  return v[Fields.ObjectFieldID_LinkedObjectID] == null && v[Fields.ObjectFieldID_LinkedObjectID_Name] != null;
                }).map(function (v) {
                  return v[Fields.ObjectFieldID_LinkedObjectID_Name];
                });

                if (viewsNames.length) {
                  _context8.next = 12;
                  break;
                }

                return _context8.abrupt("return", views);

              case 12:
                _context8.next = 14;
                return loadAppObjectsCollection({
                  Name: viewsNames
                });

              case 14:
                loaded = _context8.sent;
                obj = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context8.prev = 19;

                for (_iterator = loaded[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  view = _step.value;
                  obj[view.Name] = view;
                }

                _context8.next = 27;
                break;

              case 23:
                _context8.prev = 23;
                _context8.t0 = _context8["catch"](19);
                _didIteratorError = true;
                _iteratorError = _context8.t0;

              case 27:
                _context8.prev = 27;
                _context8.prev = 28;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 30:
                _context8.prev = 30;

                if (!_didIteratorError) {
                  _context8.next = 33;
                  break;
                }

                throw _iteratorError;

              case 33:
                return _context8.finish(30);

              case 34:
                return _context8.finish(27);

              case 35:
                return _context8.abrupt("return", views.map(function (v) {
                  var name = v[Fields.ObjectFieldID_LinkedObjectID_Name];

                  if (obj.hasOwnProperty(name)) {
                    v[Fields.ObjectFieldID_LinkedObjectID] = obj[name][Fields.ID];
                    v[Fields.DisplayField] = obj[name][Fields.DisplayObjectFieldID_Name];
                    v[Fields.ObjectFieldID_KeyObjectFieldID_Name] = obj[name][Fields.KeyObjectFieldID_Name];
                  }

                  return v;
                }));

              case 36:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[19, 23, 27, 35], [28,, 30, 34]]);
      }));

      function onEditorPreparing(_x7) {
        return _onEditorPreparing.apply(this, arguments);
      }

      return onEditorPreparing;
    }()
  }, {
    key: "resetSettings",
    value: function resetSettings() {
      var lsKey = this.getLSName();
      var lsColumns = getSSTableCols(lsKey);
      setSSTableCols(lsKey, lsColumns.map(function (lsCol) {
        delete lsCol['filterValue'];
        delete lsCol['width'];
        delete lsCol['realOperation'];
        delete lsCol['fixed'];
        delete lsCol['fixedPosition'];
        delete lsCol['sortOrder'];
        delete lsCol['sortIndex'];
        delete lsCol['visible'];
        delete lsCol['visibleIndex'];
        return lsCol;
      }));
      sessionStorage.removeItem("".concat(lsKey, "-filter"));
      sessionStorage.removeItem("".concat(lsKey, "-row-filter"));
      localStorage.removeItem("".concat(lsKey, "-filter"));
      localStorage.removeItem("".concat(lsKey, "-row-filter"));
      tbButtonsToggleAttrs(['show-header-row-filter'], false, this.formUUID);
    }
  }, {
    key: "updateConfig",
    value: function updateConfig() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _props$pageSize = props.pageSize,
          pageSize = _props$pageSize === void 0 ? 50 : _props$pageSize;

      if (isInit) {
        this._config.pageSize = pageSize;
      }
    }
    /**
     * @param {object} nextData
     * @param {array} nextViews
     * @param {object} formEvents
     * @param {number} rowIndex
     * @param {string} funcName
     * @param {object} props
     * @param {String} [errorMessage]
     * @return {Promise}
     */

  }, {
    key: "updateUserEvent",
    value: function updateUserEvent() {
      var _this5 = this;

      var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          nextData = _ref23.nextData,
          nextView = _ref23.nextView,
          _ref23$formEvents = _ref23.formEvents,
          formEvents = _ref23$formEvents === void 0 ? {} : _ref23$formEvents,
          rowIndex = _ref23.rowIndex,
          funcName = _ref23.funcName,
          _ref23$props = _ref23.props,
          props = _ref23$props === void 0 ? {} : _ref23$props,
          errorMessage = _ref23.errorMessage;

      if (!Array.isArray(nextView)) return Promise.reject(new Error('nextView must be an array'));

      if (errorMessage) {
        showSnackBar({
          type: System.SNACKBAR_TYPES.Error,
          message: errorMessage
        });
      }

      if (!objectsEqual(this.viewSource, nextView)) {
        this.viewSource = this.viewSource.map(function (view) {
          var next = nextView.find(function (nv) {
            return nv.Name === view.Name;
          });

          if (next && next[System._Changed]) {
            next[System._Changed] = false;
            _this5.viewChanged = true;
            return next;
          }

          return view;
        });
      }

      _.each(formEvents, function (event, eventName) {
        if (typeof event === 'function') {
          _this5.formEvents[eventName] = event;
        }
      });

      this.updateConfig(props, funcName === 'formInit');

      if (rowIndex === -1) {
        this.updating = false;
        return Promise.resolve({});
      }

      return new Promise(function (resolve) {
        if (_this5.inlineEditing() && _this5.updating) {
          _this5.sourceDataToColumnData(nextData, rowIndex).then(function (data) {
            var table = _this5.instance();

            var rowData = table.getVisibleRows().find(function (row) {
              return row.rowIndex === rowIndex;
            });
            _this5.editingRowInfo = data;

            try {
              table.beginUpdate();

              _.each(data, function (val, dataField) {
                //чтобы лишний раз не дергать таблицу
                if (rowData && data[dataField] === rowData.data[dataField]) return;

                if (_this5.colSetValueFuncs.has(dataField)) {
                  _this5.colSetValueFuncs.get(dataField)(val);
                } else {
                  table.cellValue(rowIndex, dataField, val);
                }
              });
            } catch (e) {} finally {
              table.endUpdate();
              var CELL = System.EDIT_MODE.CELL;

              if (_this5.editMode === CELL) {
                if (table.hasEditData()) {
                  table.saveEditData();
                }
              }

              _this5.updating = false;
              resolve(nextData);
            }
          });
        }
      });
    }
  }, {
    key: "updateFilterForSubForm",
    value: function updateFilterForSubForm(fieldData) {
      if (this.filtersData.hasOwnProperty(this._detailObjKeyFieldName)) this.filtersData[this._detailObjKeyFieldName] = fieldData[this._masterObjKeyFieldName];
    }
  }, {
    key: "startInlineEditing",
    value: function startInlineEditing(rowIndex, columnData) {
      var CELL = System.EDIT_MODE.CELL;
      var table = this.instance();

      if (this.inlineEditing() === System.FORM_EDIT_CREATE_MODE.ADD) {
        this.initNewRowData = columnData || {};
        table.beginUpdate();

        if (this.editMode !== CELL) {
          table.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"), 'd5AddRow', true);
          table.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"), "visible", true);
        }

        sharedData.formEditProcessed = null;
        table.endUpdate();
        this.updating = false;
        table.addRow();
      } else {
        table.beginUpdate();

        if (this.editMode !== CELL) {
          table.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"), 'd5EditRowIndex', rowIndex);
          table.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"), "visible", true);
        }

        this.editingRowInfo = columnData || {};
        sharedData.formEditProcessed = null;
        table.endUpdate();
        this.updating = false;
        table.editRow(rowIndex);
      }
    }
  }, {
    key: "validateRow",
    value: function validateRow() {
      var message = this.getValidationRowData();
      if (message) throw new Error(message);
      return true;
    }
  }, {
    key: "getValidationRowData",
    value: function getValidationRowData() {
      var isValid = _toConsumableArray(this.innerValidate(this.instance()));

      return isValid.join('<br/>');
    }
  }, {
    key: "innerValidate",
    value: function innerValidate(instance) {
      var _this6 = this;

      var listMessages = [];

      try {
        _.each(this.requiredFields, function (fieldName) {
          var message = instance.getCellElement(_this6.currentRowIndex, fieldName).dxValidator('instance').validate();
          if (message && message.brokenRule) listMessages.push(message.brokenRule.message);
        });

        return listMessages;
      } catch (e) {
        return [];
      }
    }
  }, {
    key: "setModeClearQuickFiltersBtn",
    value: function setModeClearQuickFiltersBtn() {
      var _this7 = this;

      var clearQF = 'clear-quick-filter';
      var modeBtn = this.columnNames.some(function (colName) {
        var colOptions = _this7.instance().columnOption(colName);

        return colOptions.filterValue && colOptions.filterValue.toString().length || colOptions.filterValues && colOptions.filterValues.toString().length;
      });
      toolbarTableFormButtonsDisabling([clearQF], !modeBtn, this.formUUID);
    }
  }], [{
    key: "columnDataToSourceData",
    value: function columnDataToSourceData(_ref24) {
      var data = _ref24.data,
          viewSource = _ref24.viewSource,
          instance = _ref24.instance;

      var getFieldByName = function getFieldByName(fieldName) {
        return _.find(viewSource, function (item) {
          return item[Fields.Name] === fieldName;
        });
      };

      var keyField = viewSource.find(function (view) {
        return view[Fields.ObjectFieldID_IsKey];
      });
      var preparedFormData = {};

      _.each(data, function (value, key) {
        var field = getFieldByName(key);
        if (!field || field && Columns.isSystemField(field)) return;
        var isLookup = Columns.isLookup(field);
        var df = isLookup ? field[Fields.KeyFilterField] : field[Fields.ObjectFieldID_Name];
        var dataType = instance.columnOption(key, 'dataType');

        switch (_typeof(value)) {
          case 'boolean':
            preparedFormData[df] = Number(value);
            break;

          case 'string':
            var val = value;

            if (isLookup) {
              val = data[System.SYSTEM_PREFIX + key];
            }
            /**
             * У новых записей ID это гуид. Идет провердка для ключевых полей
             */


            if (val !== value && _typeof(val) === _typeof(value) && field.ID === keyField.ID) //для новых значений
              val = value;
            preparedFormData[df] = val;

            if (isDateByTypeStr(dataType)) {
              preparedFormData[df] = formatDateToAPI(new Date(val), System.FIELD_EDITOR_TYPE.DATETIME === dataType);
            }

            break;

          case 'number':
            if (field[Fields.ObjectFieldID_NumberScale] != null) {
              preparedFormData[df] = Number(Number.parseFloat(value).toFixed(field[Fields.ObjectFieldID_NumberScale]));
            } else {
              preparedFormData[df] = value;
            }

            break;

          default:
            preparedFormData[df] = value;
        }
      });

      return preparedFormData;
    }
  }]);

  return Configurator;
}();

export { Configurator as default };